var React = require('react');

function UnlockIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"className":"primary-fill","d":"M54.974,32.695a5.8,5.8,0,0,0-5.8-5.8H26.123V20.05a10.829,10.829,0,1,1,21.653,0H50.1a13.148,13.148,0,1,0-26.3,0l0,6.926a5.8,5.8,0,0,0-4.872,5.719V51.1a5.8,5.8,0,0,0,5.8,5.8H49.174a5.8,5.8,0,0,0,5.8-5.8Zm-2.32,18.4a3.48,3.48,0,0,1-3.48,3.48H24.73a3.48,3.48,0,0,1-3.48-3.48v-18.4a3.48,3.48,0,0,1,3.48-3.48H49.174a3.48,3.48,0,0,1,3.48,3.48Z","transform":"translate(-13261.93 -14711.9)"}));
}

UnlockIcon.defaultProps = {"viewBox":"-13243.5 -14705.5 37.044 51","className":"unlock icon"};

module.exports = UnlockIcon;

UnlockIcon.default = UnlockIcon;
